import React from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent,
  Box,
  Typography,
  IconButton
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import FlowDetails from './FlowDetails';

function ContractDialog({ open, onClose, contract }) {
  // Validación temprana
  if (!open || !contract) return null;

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="md" 
      fullWidth
      PaperProps={{
        sx: { minHeight: '80vh' }
      }}
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">
            Contrato Digital: {contract.nombre} {contract.apellido}
          </Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent>
        {/* Información básica del contrato */}
        <Box mb={3}>
          <Typography variant="subtitle1" gutterBottom>
            Información del Cliente
          </Typography>
          <Typography variant="body2">
            Documento: {contract.documento_tipo} {contract.documento_id}
          </Typography>
          <Typography variant="body2">
            Email: {contract.email}
          </Typography>
          <Typography variant="body2">
            Duración: {contract.duracion} meses
          </Typography>
        </Box>

        {/* Componente de flujo del contrato */}
        <FlowDetails 
          contract={contract} 
          embedded={true}
        />
      </DialogContent>
    </Dialog>
  );
}

export default ContractDialog; 